import React from 'react'
import { Features } from './features'
import { DetailHeader } from './detail-header'
import { DetailItem } from './detail-item'
import { Condition } from './condition'
import { animated } from 'react-spring'
import useFadeInFromAvobe from 'hooks/useFadeInFromAvobe'

export const CreditDetail: React.FC<{ term: any }> = ({ term }) => {
  const props = useFadeInFromAvobe(0)

  return (
    <div className="bp-mb-12">
      {term.quotaText && (
        <animated.div style={props}>
          <DetailHeader headerText={'Detalles de tu préstamo'}/>
          <DetailItem
            weightColor="500"
            weightColorSecondary='500'
            variant="bodyText"
            mainText="Cuota:"
            tooltipText="Cuota mensual incluye capital, intereses y seguro de desgravamen."
            secontaryText={`$ ${term.quotaText}*`}
            id='quota_value'
          />
          <hr className="separador" />
          <DetailItem
            mainText="Capital:"
            variant="bodyText"
            secontaryText={`$ ${term.capital}*`}
            id='capital_value'
          />
          <DetailItem
            mainText="Total de interes:"
            variant="bodyText"
            secontaryText={`$ ${term.interes}*`}
            id='interest_value'
          />
          <DetailItem
            mainText="Total de seguro de desgravamen:"
            tooltipText="El seguro de desgravamen protege a tu familia y a tu préstamo en caso de muerte o incapacidad total."
            variant="bodyText"
            id='secure_value'
            secontaryText={`$ ${term.seguro}*`}
          />
          <DetailItem
            weightColor="500"
            weightColorSecondary='500'
            mainText="Total a pagar:"
            variant="bodyText"
            id='total_value'
            secontaryText={`$ ${term.total}*`}
          />
          <hr className="separador" />
          <Features></Features>
          <Condition />
        </animated.div>
      )}
    </div>
  )
}
